/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Generic_ErrorInputs */

const en_login_page_generic_error = /** @type {(inputs: Login_Page_Generic_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t complete sign-in. Please try again.`)
};

const de_login_page_generic_error = /** @type {(inputs: Login_Page_Generic_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anmeldung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.`)
};

const pt_br2_login_page_generic_error = /** @type {(inputs: Login_Page_Generic_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível concluir o acesso. Tente novamente.`)
};

const tr_login_page_generic_error = /** @type {(inputs: Login_Page_Generic_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş tamamlanamadı. Lütfen tekrar deneyin.`)
};

const zh_cn2_login_page_generic_error = /** @type {(inputs: Login_Page_Generic_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法完成登录。请重试。`)
};

const zh_hk2_login_page_generic_error = /** @type {(inputs: Login_Page_Generic_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法完成登入。請再試。`)
};

const ko_kr2_login_page_generic_error = /** @type {(inputs: Login_Page_Generic_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인을 완료할 수 없습니다. 다시 시도하세요.`)
};

const ru_ru2_login_page_generic_error = /** @type {(inputs: Login_Page_Generic_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось завершить вход. Попробуйте снова.`)
};

const es_419_login_page_generic_error = /** @type {(inputs: Login_Page_Generic_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo completar el inicio de sesión. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Couldn’t complete sign-in. Please try again." |
*
* @param {Login_Page_Generic_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_generic_error = /** @type {((inputs?: Login_Page_Generic_ErrorInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Generic_ErrorInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_generic_error(inputs)
	if (locale === "de") return de_login_page_generic_error(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_generic_error(inputs)
	if (locale === "tr") return tr_login_page_generic_error(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_generic_error(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_generic_error(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_generic_error(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_generic_error(inputs)
	return es_419_login_page_generic_error(inputs)
});